<template>
    <div class="container">
        <div class="row h-100 register">
            <div class="col-8 mx-auto  p-5 bg-white shadow-sm">
                <h2 class="h2 text-center pb-3">
                    Welcome back
                </h2>
                <p class="text-center">Log into your MySwitchPro account dashboard</p>
                <hr class="w-25">
                <div class="row">
                    <div class="col-12 col-lg-10 mx-auto ">
                        <login-form />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from "@/components/auth/LoginForm";
import {EventBus, events} from "@/utils/event-bus";
import store from "@/store"

export default {
    name: "Login.vue",
    components: {LoginForm},
    mounted() {
        let that = this;
        EventBus.$on(events.auth.signin, () => {
            that.$router.push({name: 'Dashboard'})
        })
    },
    beforeRouteEnter: function (to, from, next) {
        if(store.getters['auth/isUser']){
            next({name: 'Dashboard'})
        } else {
            next()
        }
    }
}
</script>


<style scoped lang="scss">
.register {
    min-height: calc(100vh - 145px);
}
</style>
